import React from 'react';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from './theme';
import { GlobalStyle } from './styles/GlobalStyle';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';

import styled from 'styled-components';

const Section = styled.section`
  padding: 2rem;
  min-height: 100vh;
`;

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <GlobalStyle />
      <Navbar />
      <Section id="home">
        <Hero />
      </Section>
      <Section id="about">
        <About />
      <Section id="experience">
        <Experience />
      </Section>
      </Section>
      <Section id="skills">
        <Skills />
      </Section>
      <Section id="projects">

      
        <Projects />
      </Section>
      <Section id="contact">
        <Contact />
      </Section>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
